import { render, staticRenderFns } from "./send-sms-tool.vue?vue&type=template&id=8ed3deda"
import script from "./send-sms-tool.vue?vue&type=script&lang=js"
export * from "./send-sms-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports